import { defineMessages } from 'react-intl';

export default defineMessages({
    scheduledItems: {
        id: 'policy.common.component.policy-dwelling-info.Scheduled Items',
        defaultMessage: 'Scheduled Items'
    }
});
